import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 注册积分商城相关路由
 */
export default [
  // 邀请活动首页
  route('/activity', 'activity', component('activity/index')),
  route('/activity_progress', 'activityProgress', component('activity/activityProgress')),
  route('/activity_poster', 'activityPoster', component('activity/activityPoster')),
  route('/activity_recommend', 'activityRecommend', component('activity/activityRecommend')),
  route('/recommend_index', 'recommendIndex', component('activity/recommendIndex')),
  route('/activity_deposit', 'activityDeposit', component('activity/activityDeposit')),
  // 定金落地页
  route('/earnestMoney', 'earnestMoney', component('activity/earnestMoney')),

  route('/shareActivity', 'shareActivity', component('activity/shareActivity'), {
    noKeepAlive: true
  }),
  route('/shareActivitySubmit', 'shareActivitySubmit', component('activity/shareActivitySubmit'), {}),
  route('/shareActivityResult', 'shareActivityResult', component('activity/shareActivityResult'), {
    noKeepAlive: true
  }),
  // 2023 友邻节活动
  route('/vipActivity', 'vipActivity', component('activity/vip-activity/index'), {}),
  route('/foreverVip', 'foreverVip', component('activity/vip-activity/foreverVip'), {}),
  route('/vipGroup', 'vipGroup', component('activity/vip-activity/vipGroup'), {}),
  route('/receivePage', 'receivePage', component('activity/receivePage/index'), {
    noKeepAlive: true
  }),
  // 礼品卡转介绍
  route('/giftCardActivity', 'giftCardActivity', component('activity/index')),
  route('/giftCardProgress', 'giftCardProgress', component('activity/giftCardProgress'))
]
